module.exports = __webpack_public_path__ + "media/images/icons/email_notification-df12d0a663de7fa2cdd46881c8d0e3de.svg";